<template>
  <div class="workbench-page" v-loading="loading" element-loading-text="加载中">
    <div class="tab">工作台</div>
    <div class="main-container">
      <!-- 左侧主要内容区 -->
      <div class="left-content">
        <!-- 目标列表 -->
        <GoalCardListInfo
          :currentMonth="currentMonth"
          :goalList="goalList"
          :roleType="roleType"
          @changeMonth="changeMonthHandle"
          @cardClick="showOrHideModalHandle('showGoalDetail', $event)"
          @yearGoalClick="showOrHideModalHandle('showYearGoalDetailModal')"
        />

        <!-- 团队完成情况 -->
        <TeamGoalFinishInfo
          v-if="Number(roleType) !== 3"
          :roleType="roleType"
          :teamData="teamData"
          :teamColumns="teamColumns"
          @teamClick="showOrHideModalHandle('showFullScreenModal', $event)"
        />

        <!-- 推进中/长期维护/已签约 -->
        <ClueListInfo
          :showTeamCol="Number(roleType) === 1"
          :showFollowerCol="[1, 2].includes(Number(roleType))"
          :showAddClueBtn="false"
          @addClue="showOrHideModalHandle('showAddClue')"
          @nameClick="showOrHideModalHandle('showClueDetail', $event)"
          @followerClick="showOrHideModalHandle('showFullScreenModal', $event)"
        />

        <!-- 拜访次数统计 -->
        <VisitNumInfo
          v-if="[2, 3].includes(Number(roleType))"
          :showFollowerCol="Number(roleType) === 2"
          @nameClick="showOrHideModalHandle('showClueDetail', $event)"
        />
      </div>

      <!-- 右侧待处理事项 -->
      <RightAreaContent
        @pendingCardClick="showOrHideModalHandle('showTransferClueApply', $event)"
        @rejectClueApply="showOrHideModalHandle('showRejectClueApply', $event)"
        @agreeClueApply="agreeApplyHandle"
        @poolCardClick="showOrHideModalHandle('showClueDetail', $event)"
        @viewAllClick="showOrHideModalHandle('showPublicSeaClue')"
      />
    </div>

    <!-- 全屏弹窗遮罩层 -->
    <div v-if="modalInfo.showFullScreenModal" class="back-drop">
      <!-- 小组/个人工作台 -->
      <GroupAndPersonWorkbench
        v-if="modalInfo.showFullScreenModal"
        :month="currentMonth"
        :groupType="currentTeamInfo.groupType || 2"
        :groupInfoId="currentTeamInfo.groupInfoId || ''"
        :workNumber="currentTeamInfo.workNumber || ''"
        :title="currentTeamInfo.teamName || (Number(roleType) === 1 ? (currentClueInfo.groupName + '-' + currentClueInfo.followerWorkName) : currentClueInfo.followerWorkName)"
        @back="showOrHideModalHandle('showFullScreenModal')"
        @cardClick="showOrHideModalHandle('showGoalDetail', $event)"
        @nameClick="showOrHideModalHandle('showClueDetail', $event)"
      />
    </div>

    <!-- 月/季度/年目标卡片详情弹窗 -->
    <CustomModal
      v-model="modalInfo.showGoalDetail"
      :title="modalInfo.modalTitle"
      width="1100px"
      top="50px"
      :showSubmitBtn="false"
      cancelBtnText="关闭"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showGoalDetail')"
    >
      <GoalDetailList
        ref="goalDetailListRef"
        v-if="modalInfo.showGoalDetail"
        :groupInfoId="currentClueInfo.groupInfoId"
        :workNumber="currentClueInfo.workNumber"
        :period="currentGoalDetail.period"
        :month="currentGoalDetail.month"
        :saleStar="currentGoalDetail.saleStar"
      />
    </CustomModal>

    <!-- 本年目标详情弹窗 -->
    <CustomModal
      v-model="modalInfo.showYearGoalDetailModal"
      title="本年目标"
      width="870px"
      top="50px"
      :showSubmitBtn="false"
      cancelBtnText="关闭"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showYearGoalDetailModal')"
    >
      <YearGoalDetail
        v-if="modalInfo.showYearGoalDetailModal"
        ref="yearGoalDetailRef"
        :showStaffList="Number(roleType) !== 3"
      />
    </CustomModal>
 
    <!-- 新增线索 -->
    <CustomModal
      v-model="modalInfo.showAddClue"
      title="新增线索"
      width="800px"
      top="50px"
      :showSubmitBtn="true"
      :showCancelBtn="true"
      submitBtnText="创建"
      :modalContentNoPadding="true"
      @submitHandle="addClueSubmitHandle"
      @cancelHandle="showOrHideModalHandle('showAddClue')"
    >
      <AddClue
        ref="addClueRef"
        v-if="modalInfo.showAddClue"
        :roleType="roleType"
      />
    </CustomModal>
 
    <!-- 线索详情 -->
    <CustomModal
      v-model="modalInfo.showClueDetail"
      title="线索详情"
      :width="currentClueInfo.isPublicSea ? '600px' : '800px'"
      top="50px"
      :showSubmitBtn="false"
      :showCancelBtn="true"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showClueDetail')"
    >
      <ClueDetail
        v-if="modalInfo.showClueDetail"
        ref="clueDetailRef"
        :hasReceivedTask="currentClueInfo.clueReceived ? '1' : '0'"
        :instanceId="currentClueInfo.doctorStageId || ''"
        :doctorId="currentClueInfo.doctorId || ''"
        :showLeftContent="!currentClueInfo.isPublicSea"
        @confirmHandle="showOrHideModalHandle('showClueDetail')"
      />
      <template slot="footer">
        <el-button v-if="['S030'].includes(currentClueInfo.currentStepCode)" type="primary" plain @click="transferHandle('showContinueFollow')">再次推进</el-button>
        <el-button v-if="['S040', 'S050', 'S060'].includes(currentClueInfo.currentStepCode)" @click="transferHandle('showPublicsea')">转入公海</el-button>
        <el-button v-if="['S040', 'S050', 'S060'].includes(currentClueInfo.currentStepCode)" @click="transferHandle('showLongTime')">转长期维护</el-button>
        <el-button v-if="['S040', 'S050', 'S060'].includes(currentClueInfo.currentStepCode)" @click="transferHandle('showChangeFollower')">换跟进人</el-button>
        <el-button @click="showOrHideModalHandle('showClueDetail')">取消</el-button>
      </template>
    </CustomModal>

    <!-- 转线索申请 -->
    <CustomModal
      v-model="modalInfo.showTransferClueApply"
      title="转线索申请"
      width="800px"
      top="50px"
      :showSubmitBtn="false"
      :showCancelBtn="false"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showTransferClueApply')"
    >
      <TransferClueApply ref="transferClueApplyRef" :currentClueInfo="currentClueInfo" />
      <template slot="footer">
        <el-button @click="showOrHideModalHandle('showRejectClueApply', currentClueInfo)">拒绝</el-button>
        <el-button type="primary" plain @click="agreeApplyHandle">同意</el-button>
        <el-button @click="showOrHideModalHandle('showTransferClueApply')">取消</el-button>
      </template>
    </CustomModal>

    <!-- 拒绝申请 -->
    <CustomModal
      v-model="modalInfo.showRejectClueApply"
      :title="modalInfo.modalTitle || '拒绝申请'"
      width="600px"
      :showSubmitBtn="true"
      :showCancelBtn="true"
      :modalContentNoPadding="true"
      @submitHandle="rejectHandle"
      @cancelHandle="showOrHideModalHandle('showRejectClueApply')"
    >
      <RejectClueApply
        ref="rejectClueApplyRef"
        :currentClueInfo="currentClueInfo"
      />
    </CustomModal>

    <!-- 公海线索 -->
    <CustomModal
      v-model="modalInfo.showPublicSeaClue"
      title="公海线索"
      width="1100px"
      top="20px"
      :showSubmitBtn="false"
      :showCancelBtn="true"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showPublicSeaClue')"
    >
      <PublicSeaClueList
        v-if="modalInfo.showPublicSeaClue"
        ref="publicSeaClueListRef"
        @showDoctorDetailHandle="showOrHideModalHandle('showClueDetail', $event)"
        @transferPushHandle="transferPushHandle"
        @transferIncubateHandle="transferIncubateHandle"
        @showPublicSeaClueAssignHandle="showPublicSeaClueAssignHandle"
      />
    </CustomModal>

    <!-- 公海线索-由我分配 -->
    <CustomModal
      v-model="modalInfo.showPublicSeaClueAssign"
      title="请选择"
      width="500px"
      :showSubmitBtn="true"
      :showCancelBtn="true"
      :modalContentNoPadding="true"
      @submitHandle="assignSelfHandle"
      @cancelHandle="showOrHideModalHandle('showPublicSeaClueAssign')"
    >
      <PublicSeaClueAssign ref="publicSeaClueAssignRef" :currentClueInfo="currentClueInfo" />
    </CustomModal>
  </div>
</template>

<script>
import utils from '@/views/DoctorVisitLTC/utils/index'
import request from '@/utils/request'
const goalList = [
  { type: 'month', tag: '月度', name: '3星医生20名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 },
  { type: 'quarter', tag: '季度', name: '4星医生16名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 },
  { type: 'year', tag: '年度', name: '5星医生8名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 }
]
export default {
  data() {
    return {
      loading: false,
      roleType: '', // 1:领导 2:小组 3:个人
      currentMonth: new Date().getMonth() + 1,
      currentGoalDetail: { // 当前目标详情参数
        period: '',
        month: '',
        saleStar: ''
      },
      goalList: [], // 目标列表
      // 团队目标列配置
      teamColumns: [
        { label: '团队', prop: 'teamName', minWidth: '120', align: 'left', slotName: 'teamCell' },
        { label: '3月完成情况', prop: 'monthCell', minWidth: '180', align: 'left', slotName: 'monthCell' },
        { label: '第1季度完成情况', prop: 'quarterCell', minWidth: '180', align: 'left', slotName: 'quarterCell' },
        { label: '本年度完成情况', prop: 'yearCell', minWidth: '180', align: 'left', slotName: 'yearCell' }
      ],
      currentTeamInfo: {},
      teamData: [],

      modalInfo: {
        // 弹窗标题
        modalTitle: '',
        // 目标卡片弹窗
        showGoalDetail: false,
        // 本年目标详情弹窗
        showYearGoalDetailModal: false,
        // 新增线索弹窗
        showAddClue: false,
        // 线索详情弹窗
        showClueDetail: false,
        // 转线索申请弹窗
        showTransferClueApply: false,
        // 公海线索列表弹窗
        showPublicSeaClue: false,
        // 公海线索由我分配弹窗
        showPublicSeaClueAssign: false,
        // 全屏弹窗
        showFullScreenModal: false,
      },
      currentClueInfo: {}, // 当前操作的线索信息
    }
  },
  methods: {
    changeMonthHandle(month) {
      this.currentMonth = month
      this.getGoalData()
    },

    async getRoleType() {
      try {
        const res = await request.get('/cluepool/user/role', {}, '')
        if (res.code === 200) {
          this.roleType = res.data || 0
        } else {
          this.$message.error(res.message)
          console.error('获取角色类型失败:', res.message)
        }
      } catch (error) {
        console.error('获取角色类型失败:', res.message)
      }
    },

    // 获取目标数据
    async getGoalData() {
      const params = {
        month: this.currentMonth,
        quarter: Math.floor((this.currentMonth - 1) / 3) + 1,
        year: new Date().getFullYear()
      }
      this.loading = true
      try {
        const res = await request.get('/cluepool/pc/admin/dashboard/target/detail', params, '')
        if (res.code === 200) {
          this.getGoalCardData(res.data || {})
          this.getTeamData(res.data || {})
        }
      } catch (error) {
        console.error('获取数据失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 处理目标数据
    getGoalCardData (data = {}) {
      const info = {
        month: 'monthTargetStartInfo',
        quarter: 'quarterTargetStartInfo',
        year: 'yearTargetStartInfo'
      }
      this.goalList = goalList.map(item => {
        const currentItemList = data[info[item.type]] || []
        if (currentItemList.length > 0) {
          return currentItemList.map(ite => {
            return {
              ...item,
              ...ite,
              name: (ite.saleStar || 0) + '星医生' + (ite.targetNumber || 0) + '名',
              finishTargetNumber: ite.finishTargetNumber || 0,
              targetNumber: ite.targetNumber || 0,
              percentage: Math.min(100, ((ite.finishTargetNumber || 0) / (ite.targetNumber || 1)) * 100)
            }
          })
        } else {
          return []
        }
      }).flat()
    },

    // 处理团队数据
    getTeamData (data = {}) {
      const key = 'groupName'
      const teamInfo = {}
      if (data.monthTargetCompleteInfo) {
        data.monthTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            monthInfo: el
          }
        })
      }
      if (data.quarterTargetCompleteInfo) {
        data.quarterTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            quarterInfo: el
          }
        })
      }
      if (data.yearTargetCompleteInfo) {
        data.yearTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            yearInfo: el
          }
        })
      }
      this.teamColumns = (this.teamColumns || []).map(item => {
        switch (item.prop) {
          case 'teamName':
            item.label = this.roleType === 1 ? '团队名称' : '成员'
            break
          case 'monthCell':
            item.label = this.currentMonth + '月完成情况'
            break
          case 'quarterCell':
            item.label = '第' + Math.floor((this.currentMonth - 1) / 3 + 1) + '季度完成情况'
            break
          default:
            break
        }
        return item
      })
      const teamData = []
      for (const key in teamInfo) {
        const info = teamInfo[key] || {}
        const groupType = (info.monthInfo || info.quarterInfo || info.yearInfo || {}).groupType || ''
        const groupInfoId = (info.monthInfo || info.quarterInfo || info.yearInfo || {}).groupInfoId || ''
        const workNumber = (info.monthInfo || info.quarterInfo || info.yearInfo || {}).workNumber || ''
        teamData.push({
          groupName: key,
          teamName: key,
          groupType,
          groupInfoId,
          workNumber,
          monthInfo: info.monthInfo,
          quarterInfo: info.quarterInfo,
          yearInfo: info.yearInfo
        })
      }
      this.teamData = teamData
    },

    // 显示或隐藏弹窗
    showOrHideModalHandle(modalName, itemInfo) {
      this.modalInfo[modalName] = !this.modalInfo[modalName]
      if (itemInfo) {
        // 如果是全屏展示小组/成员数据，则赋值当前团队信息，同时还需要赋值当前线索信息，因为有可能是从线索列表中点击跟进人触发的
        if (modalName === 'showFullScreenModal') {
          this.currentTeamInfo = itemInfo || {}
        }
        this.currentClueInfo = itemInfo || {}
        switch (modalName) {
          // 目标卡片弹窗
          case 'showGoalDetail':
            const periodInfo = {
              month: '3',
              quarter: '2',
              year: '1'
            }
            this.modalInfo.modalTitle = itemInfo.tag + '目标完成详情'
            this.currentGoalDetail = {
              period: periodInfo[itemInfo.type] || '',
              month: this.currentMonth,
              saleStar: itemInfo.saleStar || ''
            }
            break
          case 'showRejectClueApply':
            this.modalInfo.modalTitle = '拒绝【' + itemInfo.applyType + '】申请'
            break
          default:
            break
        }
      } else {
        this.modalInfo.modalTitle = ''
      }
    },

    // 拒绝待处理申请
    async rejectHandle() {
      if (this.$refs.rejectClueApplyRef) {
        const isFinish = await this.$refs.rejectClueApplyRef.submitHandle()
        console.log('isFinish', isFinish)
        if (isFinish) {
          this.showOrHideModalHandle('showRejectClueApply')
        }
      }
    },

    // 同意待处理申请
    async agreeApplyHandle(itemInfo) {
      if (itemInfo) {
        this.currentClueInfo = itemInfo
        const title = '同意该申请?'
        const message = '同意后该线索将转入公海'
        const isConfirm = await utils.messageBoxConfirm({ title, message })
        if (isConfirm) {
          this.$message.success('操作成功')
        }
      }
    },

    // 线索详情弹窗底部按钮操作
    transferHandle(modalName) {
      this.$refs.clueDetailRef.showOrHideModalHandle(modalName)
    },

    // 转推进池
    async transferPushHandle(itemInfo) {
      const confirm = await utils.messageBoxConfirm({
        message: '转推进池后，引进专员可以进行领取'
      })
      if (confirm) {
        this.$message.success(`已将 ${itemInfo.doctorName} 转入孵化池`)
      }
    },

    // 转孵化池
    async transferIncubateHandle(itemInfo) {
      const confirm = await utils.messageBoxConfirm({
        message: '转孵化池后，引进专员不可领取'
      })
      if (confirm) {
        this.$message.success(`已将 ${itemInfo.doctorName} 转入孵化池`)
      }
    },

    // 显示由我分配弹窗
    showPublicSeaClueAssignHandle(itemInfo) {
      if (itemInfo) this.currentClueInfo = itemInfo
      this.showOrHideModalHandle('showPublicSeaClueAssign')
    },

    // 由我分配弹窗提交
    async assignSelfHandle() {
      if (this.$refs.publicSeaClueAssignRef.submitHandle) {
        const isFinish = await this.$refs.publicSeaClueAssignRef.submitHandle()
        console.log('由我分配提交', isFinish)
        if (isFinish) {
          this.showOrHideModalHandle('showPublicSeaClueAssign')
          // 如果是公海线索弹窗列表页面，则刷新列表数据
          // if (this.$refs.publicSeaClueListRef) {
          //   this.$refs.publicSeaClueListRef.getList()
          // }
        }
      }
    },

    // 新增线索提交
    async addClueSubmitHandle() {
      if (this.$refs.addClueRef.submitHandle) {
        const isFinish = await this.$refs.addClueRef.submitHandle()
        if (isFinish) {
          // 校验通过，执行提交逻辑
          this.$message.success('新增线索成功')
          this.showOrHideModalHandle('showAddClue')
          // 重置表单
          this.$refs.addClueRef.resetForm()
        }
      }
    }
  },
  mounted() {
    this.getRoleType()
    this.getGoalData()
  },
  components: {
    GoalCardListInfo: () => import('./components/GoalCardListInfo.vue'),
    TeamGoalFinishInfo: () => import('./components/TeamGoalFinishInfo.vue'),
    ClueListInfo: () => import('./components/ClueListInfo.vue'),
    VisitNumInfo: () => import('./components/VisitNumInfo.vue'),
    GroupAndPersonWorkbench: () => import('./components/GroupAndPersonWorkbench.vue'),
    RightAreaContent: () => import('./components/RightAreaContent.vue'),
    CustomModal: () => import('@/views/DoctorVisitLTC/components/customModal/Custom_Modal.vue'),
    GoalDetailList: () => import('./components/modal/GoalDetailList.vue'),
    YearGoalDetail: () => import('./components/modal/YearGoalDetail.vue'),
    ClueDetail: () => import('./components/modal/ClueDetail.vue'),
    AddClue: () => import('./components/modal/AddClue.vue'),
    TransferClueApply: () => import('./components/modal/TransferClueApply.vue'),
    RejectClueApply: () => import('./components/modal/RejectClueApply.vue'),
    PublicSeaClueList: () => import('./components/modal/PublicSeaClueList.vue'),
    PublicSeaClueAssign: () => import('./components/modal/PublicSeaClueAssign.vue')
  }
}
</script>

<style scoped lang="less">
.workbench-page {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #F5F5F5;

  .tab {
    padding: 0 16px;
    height: 48px;
    line-height: 48px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    font-weight: 600;
  }

  .main-container {
    display: flex;
    gap: 16px;
  }

  // 全屏弹窗遮罩层
  .back-drop {
    position: fixed;
    top: 48px;
    left: 0;
    width: 100%;
    height: calc(100% - 48px);
    background: #FFF;
    z-index: 999;
  }
}

// 左侧内容区
.left-content {
  flex: 1;
  height: calc(100vh - 102px);
  overflow-y: auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

// 响应式适配
// @media screen and (max-width: 1366px) {
//   .main-container {
//     flex-direction: column;
//   }

//   .right-sidebar {
//     width: 100%;
//   }

//   .goal-cards {
//     flex-direction: column;
//   }
// }

</style>
<style lang="less">
// 线索详情弹窗底部按钮样式优化
.el-dialog__footer {
  .el-button {
    &.is-plain {
      &:hover {
        background-color: #e8f4ff;
        border-color: #1890FF;
        color: #1890FF;
      }
    }
  }
}
</style>